<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-4" v-else>

      <v-row class="my-0">
        <v-col cols="12" class="pt-0">
          <v-row>
            <v-col cols="12" md="7" class="d-flex">
              <v-btn
                class="white--text px-4 mr-2"
                small outlined rounded color="primary"
                @click="$router.push({name: 'orders'})"
              >
                <v-icon left small>mdi-chevron-left</v-icon>
                Назад
              </v-btn>

              <v-btn
                class="white--text px-4"
                outlined small rounded color="primary"
                @click="dialog = true"
              >
                <v-icon left small>mdi-plus</v-icon>Добавить
              </v-btn>
            </v-col>
          </v-row>

          <PageTable
            :table-loading="tableLoading"
            :table-headers="tableHeaders"
            :table-items="orderLinesDTO.list"
            filter
          >
            <template v-slot:item.actions="{ item }">
              <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
                mdi-trash-can-outline
              </v-icon>
            </template>
          </PageTable>
        </v-col>
      </v-row>
    </div>

    <OrderLineDialog
      :dialog="dialog"
      :saveBtnLoading="btnLoading"
      :selectedItem="selectedItem"
      :isShowMode="isShowMode"
      @saveOrderLine="saveOrderLine"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeOrderLines"
      @closeModal="closeDialog"
    />

  </div>
</template>

<script>
import {
  orderApi,
  orderLineApi,
  protocolLineApi
} from '@/api'
import {
  OrderLineDtoList,
  OrderLineParent
} from '@/models'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'
import RatingLineDialog from '@/components/zvp/ratingPoints/dialogs/RatingLine'
import PageTable from '@/components/ui/Table'
import OrderLineDialog from "@/components/zvp/documentationSetup/dialogs/OrderLineDialog"

export default {
  name: 'OrderLine',

  components: {
    OrderLineDialog,
    ConfirmDialog,
    RatingLineDialog,
    PageTable
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')

    this.orderId = Number(this.$route.params.id)

    await this.getOrderLines()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'ФИО', value: 'fullName', sortable: false, align: 'start' },
      { text: 'Гражданство', value: 'citizenship.name', sortable: false, align: 'start'},
      { text: 'Номер личного дела', value: 'studentNumber', sortable: false, align: 'start'},
      { text: 'Курс', value: 'courseNumberTo.name', sortable: false, align: 'start'},
      { text: 'Группа', value: 'group.name', sortable: false, align: 'start'},
      { text: 'Номер договора', value: 'contractNumber', sortable: false, align: 'start'},
      { text: 'Дата договора', value: 'contractDateText', sortable: false, align: 'start'},
      { text: 'Основание', value: 'basedOn', sortable: false, align: 'start'},
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '50px' },
    ],

    orderLinesDTO: new OrderLineDtoList(),

    selectedItem: null,
    isShowMode: false,

    btnLoading: false,
    dataLoaded: false,
    tableLoading: false,

    dialog: false,
    confirmDialog: false,

    orderId: null
  }),

  methods: {
    async getOrderLines() {
      try {
        this.tableLoading = true
        const data = await orderLineApi.findAllByOrder(this.orderId)
        this.orderLinesDTO = new OrderLineDtoList(data)
      } catch (e) {
        this.showErrorMessage(e, 'Возникла ошибка')
      } finally {
        this.tableLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async saveOrderLine(body) {
      body.order = { id: this.orderId }
      try {
        this.saveBtnLoading = true

        body.id ? await orderLineApi.update(body) : await orderLineApi.create(body)
        await this.getOrderLines()
        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeOrderLines() {
      try {
        this.btnLoading = true

        await orderLineApi.remove(this.selectedItem.id)
        this.orderLinesDTO.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
      this.isShowMode = false
    },
  },
}
</script>

<style scoped>
</style>
